// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./sprite-small-preloader-blue.png");
var dir = previousRequest.replace("sprite-small-preloader-blue.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "sprite-small-preloader-blue.png",
	name: "sprite-small-preloader-blue",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/sprite-small-preloader-blue.png
// module id = 28
// module chunks = 4